import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { Configuration } from '../../Configuration';

@Injectable()
export class AuthenticationService {
    public token: string;
    private apiURL: string = this.config.url;

    constructor(private router: Router, private http: Http, public config: Configuration) {
        const User = JSON.parse(localStorage.getItem('User'));
        this.token = User && User.token;
    }

    login(email: string, password: string): Observable<boolean> {
        const headers = new Headers({ 'Content-Type': 'application/json' });
        const options = new RequestOptions({ headers: headers });
        return this.http.post(`${this.apiURL}account/login/`,
            JSON.stringify({ email, password }), options)
            .map((response: Response) => {
                const token = response.json() && response.json().token;
                if (token) {
                    const userid = response.json().userid;
                    this.token = token;
                    localStorage.setItem('User', JSON.stringify({ userid, token }));
                    return true;
                } else {
                    return false;
                }
            })
            .catch(err => Observable.throw(err.json()))
    }
    isAuth() {
        const user = localStorage.getItem('User');
        return !!user;
    }

    canActivate() {
        console.log(!!localStorage.getItem('User'));
        return !!localStorage.getItem('User');
    }

    logout(): void {
        // clear token remove user from local storage to log user out
        this.token = null;
        localStorage.removeItem('User');
        localStorage.removeItem('data');
    }
}


// WEBPACK FOOTER //
// ./src/app/login/AuthService/auth.service.ts